(() => {
  if (!window.visualViewport) {
    return;
  }

  let rAFTimer;
  let canvasHeight = window.visualViewport.height * window.visualViewport.scale;
  let didViewportResize = true;

  const updateProperty = () => {
    if (!didViewportResize) {
      return;
    }

    document.documentElement.style.setProperty('--visual-viewport-height', `${canvasHeight}px`);
    didViewportResize = false;
  };

  function viewportHandler(e) {
    const viewport = e.target;

    if ((Math.round(viewport.scale * 10) / 10) !== 1) {
      return;
    }

    if (canvasHeight === (viewport.height * viewport.scale)) {
      return;
    }

    didViewportResize = true;
    canvasHeight = viewport.height * viewport.scale;
    window.cancelAnimationFrame(rAFTimer);
    rAFTimer = window.requestAnimationFrame(updateProperty);
  }

  updateProperty();

  window.visualViewport.addEventListener('resize', viewportHandler);
})();
